import type { LinkOptions, RegisteredRouter } from '@tanstack/react-router';

import { Separator } from '@connected/ui/components/separator';
import { Link } from '@tanstack/react-router';

export type NavItem<
    TRouter extends RegisteredRouter = RegisteredRouter,
    TFrom extends string = string,
    TTo extends string = '',
> = Omit<LinkOptions<TRouter, TFrom, TTo>, 'search' | 'params' | 'to'> & {
    label: string;
    to?: LinkOptions<TRouter, TFrom, TTo>['to'];
    params?: Record<string, string>;
    search?: Record<string, string | undefined>;
};

type SubmenuNavigationProps = {
    items: NavItem[];
};

export function SubmenuNavigation({ items }: SubmenuNavigationProps) {
    return (
        <>
            <div className="flex items-center">
                {items.map((item, index) => {
                    const { label, to, params, search, disabled } = item;

                    // If no link is provided, render as disabled
                    if (!to || disabled) {
                        return (
                            <span
                                key={`nav-item-${label}`}
                                className={`pb-2 ${index > 0 ? 'ml-4' : ''} transition duration-200 text-text-primary/60 cursor-not-allowed`}
                            >
                                {label}
                            </span>
                        );
                    }

                    // Render as an active link
                    return (
                        <Link
                            key={`nav-item-${label}`}
                            to={to}
                            params={params}
                            search={search}
                            className={`${index > 0 ? 'ml-4' : ''} transition duration-200`}
                            inactiveProps={{
                                className:
                                    'pb-2 font-semibold text-text-black hover:text-primary hover:border-b-2 border-primary',
                            }}
                            activeProps={{
                                className:
                                    'pb-2 font-semibold text-primary hover:!text-primary border-b-2 border-primary',
                            }}
                        >
                            {label}
                        </Link>
                    );
                })}
            </div>
            <Separator className="mb-10" />
        </>
    );
}
